import { GET_ALL_User, GET_USER_DETAILS,GET_USER_SUBSCRIPTION_HISTORY,GET_ALL_CARDS,GET_USER_SUBSCRIPTION_INFO,GET_USER_IP_LIST } from "./actions";

const initialState = {
  userList: {
    docs: [],
    totalDocs: 0,
    limit: 10,
    page: 1,
    totalPages: 0,
    pagingCounter: 0,
    hasPrevPage: false,
    hasNextPage: false,
    prevPage: null,
    nextPage: null,
  },
  subscriptionHistoryList: {
    docs: [],
    totalDocs: 0,
    limit: 10,
    page: 1,
    totalPages: 0,
    pagingCounter: 0,
    hasPrevPage: false,
    hasNextPage: false,
    prevPage: null,
    nextPage: null,
  },
  userIpList:{
    docs: [],
    totalDocs: 0,
    limit: 10,
    page: 1,
    totalPages: 0,
    pagingCounter: 0,
    hasPrevPage: false,
    hasNextPage: false,
    prevPage: null,
    nextPage: null,   
  },
  getUserData: {},
UserSubscriptionInfo:{},
  loading: true,
};

const userReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case GET_ALL_User:
      return {
        ...state,
        userList: payload,
        loading: false,
      };

    case GET_USER_DETAILS:
      return {
        ...state,
        getUserData: payload,
        loading: false,
      };
    case GET_USER_SUBSCRIPTION_HISTORY:
      return{
        ...state,
        subscriptionHistoryList:payload
      }
      case GET_ALL_CARDS:
        return {
          ...state,
          allCards: payload,
         
        };
      case GET_USER_SUBSCRIPTION_INFO:
        return{
          ...state,
          UserSubscriptionInfo:payload
        }
      case GET_USER_IP_LIST:
        return{
          ...state,
          userIpList:payload
        }
    default:
      return state;
  }
};
export default userReducer;
